import type { AmountWithType, BillablePrice } from './api/api'
import { PriceParser } from './api/mappers'

interface BillablePriceManagerData {
  billablePricesOnCustomer: BillablePrice[]
  billablePricesOnTemplate: BillablePrice[]
}

export class BillablePriceManager {
  billablePricesOnCustomer: BillablePrice[]
  billablePricesOnTemplate: BillablePrice[]

  constructor(data: BillablePriceManagerData) {
    this.billablePricesOnCustomer = data.billablePricesOnCustomer
    this.billablePricesOnTemplate = data.billablePricesOnTemplate
  }

  getPriceForBillable(billableId: string): BillablePrice | undefined {
    const priceOnCustomer = this.billablePricesOnCustomer.find((p) => p.billableId === billableId)

    if (priceOnCustomer) return priceOnCustomer

    const priceOnTemplate = this.billablePricesOnTemplate.find((p) => p.billableId === billableId)

    return priceOnTemplate
  }

  getAmountWithTypeFromBillable(billableId: string): AmountWithType[] {
    const parser = new PriceParser()

    const billablePrice = this.getPriceForBillable(billableId)

    if (!billablePrice) {
      return []
    }

    return parser.parseAmountWithTypeFromConstantsAndCoefficients(billablePrice.type, billablePrice.constants, billablePrice.coefficients)
  }
}
